<div
  class="med-table-cell text--wrap"
  [ngClass]="classList"
>
  <ng-container
    *ngIf="template; else defaultCell"
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{ $implicit: value, data, column, index }"
  ></ng-container>

  <ng-template #defaultCell>{{ value }}</ng-template>
</div>
